<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row">
      <div class="col-4">
        <app-input
          label="Nome"
          v-model="admin.user.name"
          :errors="errors['user.name']"
        ></app-input>
      </div>
      <div class="col-4">
        <app-input
          label="E-mail"
          v-model="admin.user.email"
          :errors="errors['user.email']"
        ></app-input>
      </div>
      <div class="col-4">
        <b-field label="Categoria" required>
          <b-select v-model="admin.type" placeholder="Selecionar">
            <option
              v-for="type in typeOptions"
              :key="type[0]"
              :value="type[0]"
              >{{ type[1] }}</option
            >
          </b-select>
        </b-field>
      </div>
      <div class="col-3">
        <b-field label="Senha" :required="!id">
          <b-input
            v-model="admin.user.password"
            placeholder="Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
      </div>
      <div class="col-3">
        <b-field
          label="Confirmar Senha"
          :required="!id || admin.user.password != ''"
        >
          <b-input
            v-model="admin.user.password_confirmation"
            placeholder="Confirmar Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import AdminService from '@/services/admin.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import { AdminTypeLabel } from '@/enums/AdminTypeEnum';

import { required, email, minLength, sameAs } from 'vuelidate/src/validators';

export default {
  name: 'admin-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin],
  data: () => {
    return {
      loading: true,
      admin: {
        type: null,
        user: {
          name: null,
          email: null,
          password: null,
          password_confirmation: null,
        },
      },
      typeOptions: Array.from(AdminTypeLabel),
    };
  },
  validations() {
    return {
      admin: {
        type: { required },
        user: {
          name: { required },
          email: { required, email },
          password: !this.id
            ? { required, minLength: minLength(6) }
            : { minLength: minLength(this.admin.user.password === '' ? 0 : 6) },
          password_confirmation: !this.id
            ? { required, sameAsPassword: sameAs('password') }
            : this.admin.user.password === ''
            ? {}
            : { sameAsPassword: sameAs('password') },
        },
      },
    };
  },
  methods: {
    loadAdmin(id) {
      AdminService.getId(id)
        .then(({ data }) => {
          this.admin = data;
        })
        .catch(() => this.toastify('Erro ao carregar Usuário.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', this.admin);
    },
  },
  beforeMount() {
    if (this.id) this.loadAdmin(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped></style>
